import client from './index'

export const getUploadLink = () => client.post(`/upload`, {})
export const sendPhoto = ({ url = '', formData = '' }) => client.put(url, formData)
export const validateInvoice = ({ id = '', payload = '' }) => client.post(`/${id}`, payload)
export const getInvoces = (params) => client.get(`?status=${params.filterSelected}&number=${params.number}&user=${params.user}`)
export const getLastInvoice = (params) => client.get(`/last?user=${params.user}`)
